// Action types
export const UPDATE_DASHBOARD_DATA = 'UPDATE_DASHBOARD_DATA';
export const CLEAR_DASHBOARD_DATA = 'CLEAR_DASHBOARD_DATA';

// Action creator to store dashboard data
export const updateDashboardData = (dashboardData) => {
  return {
    type: UPDATE_DASHBOARD_DATA,
    payload: dashboardData,
  };
};

// Initial state for dashboard data
const initialState = {
  dashboardData: {}, // Empty object initially
};

// Reducer to handle dashboard data actions
const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: action.payload,  // Store the dashboard data
      };
    case CLEAR_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: {},  // Clear dashboard data on logout or as needed
      };
    default:
      return state;
  }
};

export default dashboardReducer;
